/* eslint-disable react/jsx-no-duplicate-props */
/* Genera la exportación de una tabla html en formato excel */

//*componentes-utiles

import React from "react";

import GeneraExporacionExcel from "../../../../src/componentes/generaExportacionExcel/GeneraExporacionExcel";

import img1 from "../../../componentes/generaExportacionExcel/bullet1.png";
import img2 from "../../../componentes/generaExportacionExcel/bullet2.png";
import acp from "../../../componentes/generaExportacionExcel/aceptar.png";

export default function cargaExcel() {
  let tabla = (
    <table className="table table-bordered tableExc" id="tid">
      <thead
        style={{
          backgroundColor: "#4c6376",
          color: "#ffffff",
          border: "1px solid white",
          height: "50px",
          verticalAlign: "top",
          textAlign: "center",
        }}
        className="theadExc"
      >
        <tr
          style={{
            backgroundColor: "#4c6376",
            color: "#ffffff",

            height: "50px",
            verticalAlign: "top",
            textAlign: "center",
          }}
        >
          <td
            rowSpan={2}
            style={{
              border: "1px solid white",
              fontWeight: "600",
            }}
            className="theadExc"
          >
            <span>Propuesta(s):</span>
          </td>
          <td
            colSpan={4}
            style={{ border: "1px solid white", fontWeight: "600" }}
          >
            <span>
              Evidencias de la fase de diseño que serán modificadas por el
              cambio:
            </span>
          </td>
          <td
            rowSpan={2}
            style={{ border: "1px solid white", fontWeight: "600" }}
          >
            <span>
              Revisión de necesidades: <br />
              (Art. 10 y 21)
            </span>
          </td>
          <td
            rowSpan={2}
            style={{ border: "1px solid white", fontWeight: "600" }}
          >
            <span>
              Relación de cambios: <br />
              (Art. 12 y 21)
            </span>
          </td>
          <td
            rowSpan={2}
            style={{ border: "1px solid white", fontWeight: "600" }}
          >
            <span>
              Plan de acción: <br />
              (Art. 15)
              <br />
              Informe de instrumentación:
              <br />
              (Art.24)
            </span>
          </td>
        </tr>
        <tr
          style={{
            backgroundColor: "#4c6376",
            color: "#ffffff",

            height: "50px",
            verticalAlign: "top",
            textAlign: "center",
          }}
        >
          <td style={{ border: "1px solid white", fontWeight: "600" }}>
            Evidencias:
            <br />
            (Art. 9 y 19)
          </td>
          <td style={{ border: "1px solid white", fontWeight: "600" }}>
            <span>
              Características: <br />
              (Art. 12 y 21)
            </span>
          </td>
          <td style={{ border: "1px solid white", fontWeight: "600" }}>
            <span>
              Pruebas a realizar: <br />
              (Art. 13 y 22)
            </span>
          </td>
          <td style={{ border: "1px solid white", fontWeight: "600" }}>
            <span>
              Reportes de pruebas: <br />
              (Art. 14 y 23)
            </span>
          </td>
        </tr>
      </thead>
      <tbody className="tbodyExc">
        <tr style={{ backgroundColor: "#e5e5e5" }}>
          <td colSpan={8} id="IdentTable">
            <span style={{ color: "#5c7796" }}>
              <img src={img1} alt="txt1" /> &nbsp;No prevista&nbsp;
            </span>
            <span title="" style={{ color: "#28a745" }}>
              <img src={img2} alt="logo" />
              Concluido
            </span>
          </td>
        </tr>
        <tr style={{ textAlign: "left", verticalAlign: "top" }}>
          <td rowSpan={5}>
            <div>
              <a href="">001147</a>
            </div>
          </td>
          <td>
            <img src={acp} alt="" />
            &nbsp; Diseño conceptual y del producto de información - Art. 15
            Fracc. I
          </td>
          <td>
            <div>
              <img src={acp} alt="" />
              &nbsp; Esquema conceptual, es decir, asociación y jerarquización
              de temas, categorías, variables y clasificaciones
            </div>
            <div>
              <img src={acp} alt="" />
              &nbsp; Diccionario de datos
            </div>
          </td>
          <td>
            <div>
              <img src={acp} alt="" />
              &nbsp; Prueba de escritorio
            </div>
          </td>
          <td rowSpan={5}>
            <div>
              <span>
                Reporte(s):
                <br />
              </span>
              <a
                href="/ssc_des/docs/analyse/495\PROOF/CPV2020 CAMBIOS EN EL DISEÑO.PDF"
                target="_blank"
                className="text-link"
              >
                <img src={acp} alt="" />
                &nbsp;
                <span title="CPV2020 CAMBIOS EN EL DISEÑO.pdf">
                  CPV2020 ...
                </span>
              </a>
            </div>
            <div>
              <span>
                Justificación(es):
                <br />
              </span>
              <a
                href="/ssc_des/docs/analyse/495\JUSTIFY/JUSTIFICACION DE NO REALIZAR PRUEBAS.PDF"
                target="_blank"
                className="text-link"
              >
                <img src={acp} alt="" />
                &nbsp;
                <span title="Justificacion de no realizar pruebas.pdf">
                  Justific...
                </span>
              </a>
            </div>
          </td>
          <td rowSpan={5}>
            <div>
              <a
                href="/ssc_des/docs/analyse/495\NR/REVISION DE NECESIDADES.PDF"
                target="_blank"
                className="text-link"
              >
                <img src={acp} alt="" />
                &nbsp;
                <span title="Revision de necesidades.pdf">Revision...</span>
              </a>
            </div>
          </td>
          <td rowSpan={5}>
            <div>
              <a
                href="/ssc_des/docs/analyse/495\CR/CPV2020 CAMBIOS EN EL DISEÑO.PDF"
                target="_blank"
              >
                <img src={acp} alt="" />
                &nbsp;
                <span title="CPV2020 CAMBIOS EN EL DISEÑO.pdf">
                  CPV2020 ...
                </span>
              </a>
            </div>
          </td>
          <td rowSpan={5}>
            <a
              href="/ssc_des/docs/analyse/495\API/CPV2020 CAMBIOS EN EL DISEÑO.PDF"
              target="_blank"
              className="text-link"
            >
              <img src={acp} alt="" />
              &nbsp;
              <span title="CPV2020 CAMBIOS EN EL DISEÑO.pdf">CPV2020 ...</span>
            </a>
          </td>
        </tr>
        <tr style={{ textAlign: "left", verticalAlign: "top" }}>
          <td>
            <img src={acp} alt="" />
            &nbsp; Diseño de los sistemas de producción y los flujos de trabajo
            - Art. 15 Fracc. II
          </td>
          <td>
            <div>
              <img src={acp} alt="" />
              &nbsp; Flujos de trabajo en tareas secuenciales
            </div>
            <div>
              <img src={acp} alt="" />
              &nbsp; Diseño de los procesos que se llevarán a cabo en producción
            </div>
          </td>
          <td>
            <div>
              <img src={acp} alt="" />
              &nbsp; Prueba de escritorio
            </div>
          </td>
        </tr>
        <tr style={{ textAlign: "left", verticalAlign: "top" }}>
          <td>
            <img src={acp} alt="" />
            &nbsp; Diseño de la captación - Art. 15 Fracc. III
          </td>
          <td>
            <div>
              <img src={acp} alt="" />
              &nbsp; Instrumentos de captación, canales y protocolos de
              intercambio; investigaciones realizadas en el diseño o adecuación
              de los instrumentos; pruebas de concepto y sus resultados y
              referencias a documentos de soporte
            </div>
            <div>
              <img src={acp} alt="" />
              &nbsp; Criterios de captación y validación
            </div>
            <div>
              <img src={acp} alt="" />
              &nbsp; Manuales operativos
            </div>
            <div>
              <img src={acp} alt="" />
              &nbsp; Estrategia operativa
            </div>
            <div>
              <img src={acp} alt="" />
              &nbsp; Diseño de la captura de datos cuando aplique
            </div>
          </td>
          <td>
            <div>
              <img src={acp} alt="" />
              &nbsp; Prueba de escritorio
            </div>
          </td>
        </tr>

        <tr style={{ textAlign: "left", verticalAlign: "top" }}>
          <td>
            <img src={acp} alt="" />
            &nbsp; Diseño del procesamiento y análisis de la producción - Art.
            15 Fracc. V
          </td>
          <td>
            <div>
              <img src={acp} alt="" />
              &nbsp; Integración de datos
            </div>
            <div>
              <img src={acp} alt="" />
              &nbsp; Codificación
            </div>
            <div>
              <img src={acp} alt="" />
              &nbsp; Validación
            </div>
            <div>
              <img src={acp} alt="" />
              &nbsp; Imputación
            </div>
            <div>
              <img src={acp} alt="" />
              &nbsp; Creación de nuevas variables o unidades (cuando aplique)
            </div>
          </td>
          <td>
            <div>
              <img src={acp} alt="" /> &nbsp;Prueba de escritorio
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  );
  let nomArchivo = "Es_CPV";
  let nomHoja = "CPV_Cada10años_2020";

  //Se le pasan 3 parametros
  //1.- la tabla html
  //2.- el nombre del archivo
  //3.- el nombre de la hoja de excel
  return (
    <>
      <div className="container container-Vista">
        <React.StrictMode>
          <h1>Genera Exportación Excel </h1>

          <GeneraExporacionExcel
            tabla={tabla}
            nomA={nomArchivo}
            nomH={nomHoja}
          />
        </React.StrictMode>
      </div>
    </>
  );
}
